<div class="flex flex-col gap-y-4">
	<app-ghost-practice-accounting-items-table
		class="col-span-2"
		title="Legal fees"
		[hst]="hst()"
		[hstTotal]="totals()?.feesHST"
		[items]="ghostPracticeConveyancingFeeItems()"
	></app-ghost-practice-accounting-items-table>
	<app-ghost-practice-accounting-items-table
		class="col-span-2"
		title="HST disbursements"
		codeColumnTitle="G/L Account"
		[hst]="hst()"
		[hstTotal]="totals()?.HSTDisbursementsHST"
		[items]="ghostPracticeHstItems()"
	></app-ghost-practice-accounting-items-table>
	<app-ghost-practice-accounting-items-table
		class="col-span-2"
		title="Non HST disbursements"
		codeColumnTitle="G/L Account"
		[items]="ghostPracticeNonHstItems()"
	></app-ghost-practice-accounting-items-table>
</div>
